import script from "./ActionMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./ActionMessage.vue?vue&type=script&setup=true&lang=js"

export default script